module.exports = __webpack_public_path__ + "static/img/chanpin-4-1.1665c11d.png";